import React from "react";
import { Checkbox } from "@material-ui/core";

import { withStyles } from '@material-ui/styles';

const MaterialCheckbox = withStyles((theme) => ({
  colorSecondary: {
    color: theme.custom.checkbox.color,
    "&:hover": {
      backgroundColor: theme.custom.checkbox.hoverBackground
    }
  },
  checked: {
    color: `${theme.custom.checkbox.checkedColor} !important`,
    "&$checked:hover": {
      backgroundColor: theme.custom.checkbox.checkedHoverBackground
    }
  }

}))(Checkbox);

export default MaterialCheckbox;